var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],staticClass:"page-container"},_vm._l((_vm.blok.body),function(blok){return _c(_vm._f("dashify")(blok.component),{key:blok._uid,tag:"component",attrs:{"blok":blok}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }